import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a58a7ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-3 loadspinner"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-chase\" data-v-8a58a7ce><div class=\"sk-chase-dot\" data-v-8a58a7ce></div><div class=\"sk-chase-dot\" data-v-8a58a7ce></div><div class=\"sk-chase-dot\" data-v-8a58a7ce></div><div class=\"sk-chase-dot\" data-v-8a58a7ce></div><div class=\"sk-chase-dot\" data-v-8a58a7ce></div><div class=\"sk-chase-dot\" data-v-8a58a7ce></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loadingState)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.loadingMessage), 1)
      ]))
    : _createCommentVNode("", true)
}